module.exports = __webpack_public_path__ + "static/img/newsBackground.344911f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/newsBackground.png
// module id = Aweu
// module chunks = 0